import { render, staticRenderFns } from "./ChangeWaitlistVehicle.vue?vue&type=template&id=2fcfb72d&scoped=true&"
import script from "./ChangeWaitlistVehicle.vue?vue&type=script&lang=js&"
export * from "./ChangeWaitlistVehicle.vue?vue&type=script&lang=js&"
import style0 from "./ChangeWaitlistVehicle.vue?vue&type=style&index=0&id=2fcfb72d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcfb72d",
  null
  
)

export default component.exports